import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SingleCardModule } from './layouts';
import { Router } from '@angular/router';
import { LoginModule } from "./shared/components/framework/login/login.component";


@Component({
  standalone: false,
  selector: 'app-unauthenticated-content',
  template: `
    <app-single-card [title]="title" [description]="description">
        <!--<router-outlet></router-outlet>-->
        <app-login></app-login>
    </app-single-card>
  `,
  styles: [`
    :host {
      width: 100%;
      height: 100%;
    }
  `]
})
export class UnauthenticatedContentComponent {

  constructor(private router: Router) { }

  get title() {
   /* const path = this.router.url.split('/')[1];
    switch (path) {
      case 'login': return 'Log In';
      case 'reset-password': return 'Reset Password';
      case 'create-account': return 'Sign Up';
      case 'change-password': return 'Change Password';
      default: return '';
    }*/
   return "";
  }

  get description() {
    return "";
  }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SingleCardModule,
    LoginModule
],
  declarations: [UnauthenticatedContentComponent],
  exports: [UnauthenticatedContentComponent]
})
export class UnauthenticatedContentModule { }
